import { pushGtmPageView } from "@utils/gtm";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** 路由变化时向 GTM dataLayer 推送虚拟 page_view */
export const useGtmPageView = () => {
  const location = useLocation();
  useEffect(() => {
    pushGtmPageView({
      page_path: `${location.pathname}${location.search}`,
      page_title: document.title,
    });
  }, [location]);
};
